import FailedAppointmentBanner from "./FailedAppointmentBanner";
export default FailedAppointmentBanner;
